import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _chunk from 'lodash/chunk';
import React, { PureComponent, Children } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import * as style from './ButtonGroup.style';
import { ButtonGroupContextProvider } from '../button-group-context';
import propTypeClassName from '../../propTypeClassName';
import { getAllowedAttributes } from '../../props-filters';

var composeButtonGroupOutfit = function composeButtonGroupOutfit() {
  var outfit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return 'quinary ' + outfit + ' expanded groupped';
};

var ButtonGroup = function (_PureComponent) {
  _inherits(ButtonGroup, _PureComponent);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _possibleConstructorReturn(this, (ButtonGroup.__proto__ || _Object$getPrototypeOf(ButtonGroup)).apply(this, arguments));
  }

  _createClass(ButtonGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          columns = _props.columns,
          outfit = _props.outfit,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['children', 'columns', 'outfit', 'className']);

      var rows = _chunk(Children.toArray(children), columns);
      var buttonGroupOutfit = composeButtonGroupOutfit(outfit);

      var allowedAttributes = getAllowedAttributes(restProps);

      return React.createElement(
        'div',
        _extends({}, allowedAttributes, { className: cx(style.buttonGroup, className) }),
        rows.map(function (row, rowIndex) {
          return React.createElement(
            'div',
            { 'data-test-id': 'ButtonGroup.row', className: style.buttonGroupRow, key: rowIndex },
            row.map(function (cell, cellIndex) {
              return React.createElement(
                'div',
                {
                  'data-test-id': 'ButtonGroup.cell',
                  className: style.buttonGroupCell,
                  key: cellIndex
                },
                React.createElement(
                  ButtonGroupContextProvider,
                  { value: { buttonGroupOutfit: buttonGroupOutfit } },
                  cell
                )
              );
            })
          );
        })
      );
    }
  }]);

  return ButtonGroup;
}(PureComponent);

ButtonGroup.propTypes = {
  /** The ButtonGroup children */
  children: PropTypes.node,
  /** Number of columns in ButtonGroup */
  columns: PropTypes.number,
  outfit: PropTypes.string,
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   */
  className: propTypeClassName
};
export default ButtonGroup;